module.exports = __webpack_public_path__ + "img/floor.c3e6c311.png";